(function () {
  var cfg = window.__CART_COOKIE_SYNC__ || {};
  var COOKIE_DOMAIN = cfg.cookieDomain || null; // e.g. ".greenfoxcompanies.com"
  var COOKIE_NAME = cfg.cookieName || "cart_qty";
  var COOKIE_MAX_AGE = Number(cfg.maxAge || (60 * 60 * 24 * 7)); // 7 days

  function setCookie(value) {
    var parts = [
      COOKIE_NAME + "=" + encodeURIComponent(String(value)),
      "Path=/",
      "SameSite=Lax",
      "Secure",
      "Max-Age=" + String(COOKIE_MAX_AGE)
    ];
    if (COOKIE_DOMAIN) parts.push("Domain=" + COOKIE_DOMAIN);
    document.cookie = parts.join("; ");
  }

  function deleteCookie() {
    var parts = [
      COOKIE_NAME + "=",
      "Path=/",
      "SameSite=Lax",
      "Secure",
      "Max-Age=0"
    ];
    if (COOKIE_DOMAIN) parts.push("Domain=" + COOKIE_DOMAIN);
    document.cookie = parts.join("; ");
  }

  async function refresh() {
    try {
      var res = await fetch("/cart.js", { credentials: "same-origin", cache: "no-store" });
      if (!res.ok) return;

      var cart = await res.json();
      var qty = Number((cart && cart.item_count) || 0);

      if (!qty) deleteCookie();
      else setCookie(qty);
    } catch (e) {}
  }

  // Load
  refresh();

  // Update after cart mutations
  var originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function () {
      return originalFetch.apply(this, arguments).then(function (res) {
        try {
          var input = arguments[0];
          var url = input && input.url ? input.url : String(input || "");
          if (/(\/cart\/(add|change|update|clear)\.js)/.test(url)) refresh();
        } catch (e) {}
        return res;
      });
    };
  }
})();